import { render, staticRenderFns } from "./OpsOnlyTag.vue?vue&type=template&id=43fc1a3d&scoped=true"
import script from "./OpsOnlyTag.vue?vue&type=script&lang=js"
export * from "./OpsOnlyTag.vue?vue&type=script&lang=js"
import style0 from "./OpsOnlyTag.vue?vue&type=style&index=0&id=43fc1a3d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc1a3d",
  null
  
)

export default component.exports